// src/utils/firebaseConfig.ts
import {initializeApp} from 'firebase/app';
import {getDatabase} from 'firebase/database';
import {getAuth, GoogleAuthProvider} from 'firebase/auth';

// Export ra ngoài vì service worker nhận thông báo đẩy cũng cần đúng bộ cấu
// hình này: nó là file tĩnh trong public/ nên CRA KHÔNG thay process.env cho nó,
// mà dev với prod lại là hai project Firebase khác nhau (nha48-6 / nha48-60271).
// Cách nối: utils/push.ts đính config vào query string lúc đăng ký worker.
export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);

// Firebase Authentication (đăng nhập Google cho chủ nhà/quản lý)
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({prompt: 'select_account'});